import { Controller } from "@hotwired/stimulus"

// Manages segment highlight/fade behavior for any chart type (stacked bar, donut, etc.).
// Connected legends call highlightSeries(key) and clearHighlight() via Stimulus outlets.
const SEGMENT_FADE_CLASS = "opacity-20"

export default class extends Controller {
  static targets = ["segment"]

  highlightSeries(key) {
    this.segmentTargets.forEach(segment => {
      if (key && segment.dataset.seriesKey !== key) {
        segment.classList.add(SEGMENT_FADE_CLASS)
      } else {
        segment.classList.remove(SEGMENT_FADE_CLASS)
      }
    })
  }

  clearHighlight() {
    this.segmentTargets.forEach(segment => {
      segment.classList.remove(SEGMENT_FADE_CLASS)
    })
  }
}
